export enum TaxiEvents {
  GetOrders = "taxi:getOrders",
  GetRouteInfo = "taxi:getRouteInfo",
  NewOrder = "taxi:newOrder",
  TakeOrder = "taxi:takeOrder",
  Start = "taxi:start",
  Rent = "taxi:rent",
  UnRent = "taxi:unRent",
  Employment = "taxi:employment",
  DeleteOrder = "taxi:delete-order",
}
